"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const AppRoot_1 = __importDefault(require("./components/AppRoot"));
require("./css/index.css");
require("./css/emoji-mart.css");
const constants_1 = require("./constants");
const startup_1 = __importDefault(require("./startup"));
document.title = constants_1.APP_TITLE;
startup_1.default().then(() => react_dom_1.default.render(react_1.default.createElement(AppRoot_1.default, null), document.getElementById("app")));
